import { render, staticRenderFns } from "./UnsynchronizedFormatListView.vue?vue&type=template&id=0f22690b&scoped=true&"
import script from "./UnsynchronizedFormatListView.vue?vue&type=script&lang=ts&"
export * from "./UnsynchronizedFormatListView.vue?vue&type=script&lang=ts&"
import style0 from "./UnsynchronizedFormatListView.vue?vue&type=style&index=0&id=0f22690b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22690b",
  null
  
)

export default component.exports